<script lang="ts">
    import { onMount } from "svelte"

    import { apiBaseURL } from "./../../config"
    import { getCarouselImages } from "./../../api"

    // Documentation: https://github.com/specious/cloud9carousel

    import "../3rdparty/cloudcarousel/jquery.min.js"
    import "../3rdparty/cloudcarousel/jquery.noconflict"
    import "../3rdparty/cloudcarousel/jquery.mousewheel.min"
    import "../3rdparty/cloudcarousel/jquery.cloud9carousel.js"

    let images = []
    let galleryId = null
    let selectedImage = null

    const getImages = async () => {
        images = await getCarouselImages()
    }

    const init = () => {
        setTimeout(() => {
            // @ts-ignore
            window.jQuery("#carousel").Cloud9Carousel({
                yOrigin: 70,
                yRadius: 70,
                itemClass: "cloud9-item",
                mouseWheel: true,
                autoPlay: true,
                speed: 2,
                smooth: true,
            })
        }, 100)
    }

    onMount(async () => {
        window.addEventListener("resize", init)
        await getImages()
        init()
    })

    const selectImage = (gId, img) => {
        galleryId = gId
        selectedImage = img
    }
</script>

<h2>Fotokarussell</h2>
<div>
    Hier einige Schnappschüsse für Sie ! Zum Vergrößern klicken Sie auf das
    Bild.
</div>

<div id="carousel">
    {#each images as gallery}
        {#each gallery.images as image}
            <img
                src="{`${apiBaseURL}cloud9carousel/${gallery.id}/${image.file.src}?filter=s`}"
                alt="{image.file.path}"
                class="cloud9-item"
                on:click="{() => selectImage(gallery.id, image)}"
            />
        {/each}
    {/each}
</div>

{#if galleryId && selectedImage}
    <div
        class="selected-image"
        on:click="{() => {
            galleryId = null
            selectedImage = null
        }}"
    >
        <img
            src="{`${apiBaseURL}cloud9carousel/${galleryId}/${selectedImage.file.src}?filter=l`}"
            alt="{selectedImage.file.path}"
        />
    </div>
{/if}

<style type="less">
    #carousel {
        width: 100%;
        height: 450px;

        img {
            border: 2px solid #fff;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
            border-radius: 10px;
            cursor: pointer;
        }
    }

    .selected-image {
        z-index: 99999;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.5);

        img {
            border: 2px solid #fff;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
            border-radius: 10px;
        }
    }
</style>
